module.exports = __webpack_public_path__ + "img/SES_192422552.1d9b9c31.jpg";